import {Injectable} from '@angular/core';

@Injectable()
export abstract class OdometerService {
  public abstract init(selector: string, initValue: number, firstUpdate: number): void;
}
